import html2canvas from 'html2canvas'
import {Dispatch, FC, SetStateAction, useState} from 'react'
import {PaymentModal} from './payment-modal/paymentModal'
import {ListLoading} from '../../../../../../_metronic/helpers/components/ListLoading'
import {Invoice} from '../core/_models'
import {PosPrint, isAPP, isPOS} from '../../../../../../_metronic/helpers'
import {BuyGoldModal} from './BuyGoldModal'
import {useAuth} from '../../../../auth'
import {hidesPayments} from '../../../../install-app/core/androidApp'
import clsx from 'clsx'
import {downloadInvoicePdf} from '../core/_requests'

type props = {
  invoice: Invoice
  fullPrint: {
    fullPrint: boolean
    setFullPrint: Dispatch<SetStateAction<boolean>>
  }
  /** The sheets are laid out; printing before that would print a half-built page. */
  printReady?: boolean
}

const PrintFooter: FC<props> = ({invoice, fullPrint, printReady = true}) => {
  const {currentUser} = useAuth()
  const [printing, setPrinting] = useState(false)
  const [pdfDownloading, setPdfDownloading] = useState(false)
  const [pdfError, setPdfError] = useState('')
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [showBuyModal, setShowBuyModal] = useState(false)
  // «پرداخت» is the seller's record of a payment, or the buyer's online payment; the Bazaar and Myket builds of the
  // Android app keep only the seller's.
  const recordsOnly =
    hidesPayments() && !currentUser?.cpl?.some((company) => Number(company.id) === Number(invoice.slid))
  const printDisabled = !isAPP && !printReady

  const incoicePrint = () => {
    if (isAPP) {
      posPrint()
    } else if (printReady) {
      window.print()
    }
  }

  const posPrint = () => {
    setPrinting(true)
    setTimeout(() => {
      const input = document.getElementById('posprintplace')
      if (input != null) {
        html2canvas(input).then((canvas) => {
          const imgData = canvas.toDataURL('image/png')
          setTimeout(() => {
            if (isPOS) {
              PosPrint(imgData)
            } else {
              setPrinting(false)
              var a = document.createElement('a') //Create <a>
              a.href = imgData //Image Base64 Goes here
              a.download = 'Image.png' //File name Here
              a.click() //Downloaded file
            }
          }, 100)
        })
      }
    }, 100)
  }

  const downloadPdf = () => {
    if (!invoice.hsh || pdfDownloading) {
      return
    }

    setPdfDownloading(true)
    setPdfError('')
    // The PDF of this page, as it is shown, whichever page the business prints with by default.
    downloadInvoicePdf(invoice.hsh, `invoice_${invoice.no || invoice.id}.pdf`, {page: 'classic'})
      .catch(() => {
        setPdfError('ساخت فایل PDF انجام نشد. چند لحظه دیگر دوباره تلاش کنید.')
      })
      .finally(() => {
        setPdfDownloading(false)
      })
  }

  return (
    <>
      {!printing && !pdfDownloading && (
        <>
          <nav className='navbar fixed-bottom navbar-light bg-light h-80px text-center shadow'>
            <div className='container-fluid'>
              <div className='btn-toolbar w-100'>
                <div className='btn-group d-flex justify-content-between w-100' role='group'>
                  {!fullPrint.fullPrint && (
                    <div
                      className={clsx('btn btn-outline-secondary', {disabled: printDisabled})}
                      aria-disabled={printDisabled}
                      title={printDisabled ? 'در حال صفحه‌بندی صورتحساب…' : undefined}
                    >
                      <div className='d-flex flex-column' onClick={incoicePrint}>
                        <i className='la la-print fs-3x'></i>
                        چاپ
                      </div>
                    </div>
                  )}
                  <div className='btn btn-outline-secondary'>
                    <div className='d-flex flex-column' onClick={downloadPdf}>
                      <i className='la la-file-pdf fs-3x'></i>
                      PDF
                    </div>
                  </div>
                  <div className={clsx('btn btn-outline-secondary', 'd-md-none')}>
                    <div
                      className='d-flex flex-column'
                      onClick={() => {
                        fullPrint.setFullPrint(!fullPrint.fullPrint)
                      }}
                    >
                      {fullPrint.fullPrint ? (
                        <>
                          <i className='la la-qrcode fs-3x'></i>
                          رسید
                        </>
                      ) : (
                        <>
                          <i className='la la-file-invoice fs-3x'></i>
                          صورتحساب کامل
                        </>
                      )}
                    </div>
                  </div>
                  {(invoice.pymr || 0) > 0 && !recordsOnly && (
                    <>
                      <div
                        className='btn btn-outline-secondary'
                        // onClick={() => {
                        //   PosPayment((invoice.ntp ?? '0').replace(/,/g, ''), invoice.hsh || '')
                        // }}
                        onClick={() => {
                          setShowPaymentModal(true)
                        }}
                      >
                        <div className='d-flex flex-column'>
                          <i className='la la-credit-card fs-3x'></i>
                          پرداخت
                        </div>
                      </div>
                      {invoice.tmpi == 3 &&
                        currentUser &&
                        currentUser.cpl &&
                        currentUser.cpl.findIndex((x) => x.id == invoice.slid) > -1 && (
                          <div
                            className='btn btn-outline-secondary'
                            // onClick={() => {
                            //   PosPayment((invoice.ntp ?? '0').replace(/,/g, ''), invoice.hsh || '')
                            // }}
                            onClick={() => {
                              setShowBuyModal(true)
                            }}
                          >
                            <div className='d-flex flex-column'>
                              <i className='la la-retweet fs-3x'></i>
                              خرید طلا
                            </div>
                          </div>
                        )}
                    </>
                  )}
                  <div className='btn btn-outline-secondary'>
                    <a
                      href='/apps/invoice-management/invoices'
                      className='d-flex flex-column text-gray-800'
                    >
                      <i className='la la-angle-left fs-3x text-gray-400'></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          {pdfError && (
            <div
              className='alert alert-danger d-flex align-items-center justify-content-between gap-3 position-fixed start-0 end-0 mx-5 mb-0 py-3'
              style={{bottom: 88, zIndex: 1031}}
              role='alert'
            >
              <span>{pdfError}</span>
              <button
                type='button'
                className='btn btn-sm btn-light-danger py-1'
                onClick={() => setPdfError('')}
              >
                بستن
              </button>
            </div>
          )}
          {showPaymentModal && (
            <PaymentModal invoice={invoice} setShowPaymentModal={setShowPaymentModal} />
          )}
          {showBuyModal && <BuyGoldModal invoice={invoice} setShowBuyModal={setShowBuyModal} />}
        </>
      )}
      {printing && <ListLoading text='چاپ صورتحساب...' />}
      {pdfDownloading && <ListLoading text='در حال آماده‌سازی PDF...' />}
    </>
  )
}

export {PrintFooter}
